import mitt from "mitt";
import Model from "../store/Model";
import {isNil} from "lodash";
import {DateTime} from "luxon";

const bus = mitt();
const useBus = () => {
    return bus;
}

const useFormWatcher = (model: Model | null, form: any, ignore: Array<string> = []): void => {
    if (model === null) {
        return;
    }

    for (const prop in {...model}) {
        if (['working', 'errors'].concat(ignore).includes(prop) || !form.hasOwnProperty(prop)) {
            continue;
        }

        form[prop] = (model as any)[prop];
    }
};

const usageChecker = async (route: string): Promise<boolean> => {
    const swalFire: any = {
        title: window.trans('attributes.you_have_relations'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1185c7',
        cancelButtonColor: '#868686',
        confirmButtonText: window.trans('actions.yes'),
        cancelButtonText: window.trans('actions.cancel')
    };
    swalFire.html = (swalFire.html = window.trans('attributes.delete_relations'));

    return await new Promise(function (resolve, reject) {
        window.api.get(route).then(async (result) => {
            if (result.data.has_relations) {
                const value = await window.Swal.fire(swalFire)
                resolve(value.isConfirmed);
            } else {
                resolve(true);
            }
        }).catch(() => {
            reject();
        })
    }) as boolean
}

const minTwoDigits = (number: number) => {
    return (number < 10 ? '0' : '') + number;
}

export default {
    install: (app: any) => {
        app.config.globalProperties.$global = window.global;

        app.config.globalProperties.$luxon = DateTime;

        app.config.globalProperties.$publicAsset = (src: string) => {
            if (src.startsWith('/')) {
                src = src.substring(1);
            }

            return window.Vapor.asset(src);
        }

        window.ucFirst = app.config.globalProperties.$ucFirst = (str: string): string => {
            if (isNil(str)) {
                return '';
            }

            return str.charAt(0).toUpperCase() + str.slice(1);
        }

        app.config.globalProperties.$bus = window.bus = mitt();

        app.config.globalProperties.$fileSizeInKbToHumanReadable = (kb: number): string => {
            if (kb < 10_000) {
                return (kb / 1024).toFixed(2) + ' kB';
            } else if (kb < 1_000_000_000) {
                return (kb / 1_048_576).toFixed(2) + ' MB';
            } else {
                return (kb / 1_073_741_824).toFixed(2) + 'GB';
            }
        }

        app.config.globalProperties.$secondsToHumanReadable = window.secondsToHumanReadable = (totalSeconds: number): string => {
            const hours = Math.floor(totalSeconds / 3600);
            totalSeconds %= 3600;
            const minutes = Math.floor(totalSeconds / 60);
            const seconds = totalSeconds % 60;

            let output = '';

            if (hours !== 0) {
                output += minTwoDigits(Math.floor(hours)) + ':';
            }

            return output
                + minTwoDigits(Math.floor(minutes))
                + ':' + minTwoDigits(Math.floor(seconds));
        }

        app.config.globalProperties.$numberToReadable = window.numberToReadable = (number: number, digits: number): string => {
            const lookup = [
                { value: 1, symbol: "" },
                { value: 1e3, symbol: "k" },
                { value: 1e6, symbol: "M" },
            ];

            const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            const item = lookup.slice().reverse().find(function(item) {
                return number >= item.value;
            });

            return item ? (number / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
        }

        window.getLogoUrl = app.config.globalProperties.$getLogoUrl = (dark: boolean): string => {
            if (window.global.theme === 'Pusic') {
                return dark ? '/assets/logo-white.svg' : '/assets/logo.svg';
            } else {
                return dark ? '/assets/logo-white-yourvirals.svg' : '/assets/logo-yourvirals.svg';
            }
        }
    }
}

export {
    useBus,
    useFormWatcher,
    usageChecker,
}
